import React from "react";

import Heading from "core/Heading";
import DeniedGrid from "./DeniedGrid";
import useSubmissionsCounts from "./useSubmissionsCounts";

const SubmissionsDenied = () => {
    const { deniedCount: totalCount } = useSubmissionsCounts();

    let content = null;

    if (!totalCount) {
        content = <Heading size="md">No photos have been denied.</Heading>;
    } else {
        content = <DeniedGrid />;
    }

    return <div data-testid="submissions-denied">{content}</div>;
};

export default SubmissionsDenied;
